import EditPromotion from './components/EditPromotion';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  createPromotion,
  updatePromotion,
  loadPromotions
} from '../../shared/redux/entities/actions';
import './EditPromotion.css'
import has from "lodash/has";

function mapStateToProps(state,props){
  const promotionId = props.match.params.promotionId,
      brandId = props.brandId;
  return {
    brandId:brandId,
    promotionId:promotionId,
    needsLoading:!has(state,['entities','agencies',brandId,'name']),
    isCreate:promotionId === 'new',
    agencyId:get(state,['entities','companies',brandId,'agencyId']),
    promotion:get(state,['entities','promotions',promotionId], null)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createPromotion,
    updatePromotion,
    loadPromotions
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditPromotion));



// WEBPACK FOOTER //
// ./src/routes/EditPromotion/index.js